import { render, staticRenderFns } from "./CancellationModal.vue?vue&type=template&id=50681591&scoped=true&"
import script from "./CancellationModal.vue?vue&type=script&lang=js&"
export * from "./CancellationModal.vue?vue&type=script&lang=js&"
import style0 from "./CancellationModal.vue?vue&type=style&index=0&id=50681591&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50681591",
  null
  
)

export default component.exports